/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DmvsDtiDocsImportDocCreateRequest = {} | null | undefined;
export type DmvsDtiDocsImportDocCreateResponse = any;

export type DmvsDtiDocsImportDocCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/dmvs_dti_docs/{id}/import_doc/
 *
 * ```yaml
 * operationId: dmvs_dti_docs_import_doc_create
 * tags:
 *   - dmvs_dti_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dmvsDtiDocsImportDocCreateOperation = ({
  id,
  ...rest
}: DmvsDtiDocsImportDocCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/dmvs_dti_docs/${id}/import_doc/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/dmvs_dti_docs/{id}/import_doc/' };
  };

/**
 * POST /dmx-server/dmvs_dti_docs/{id}/import_doc/
 *
 * ```yaml
 * operationId: dmvs_dti_docs_import_doc_create
 * tags:
 *   - dmvs_dti_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dmvsDtiDocsImportDocCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DmvsDtiDocsImportDocCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = dmvsDtiDocsImportDocCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
